/**
 * Reads a single environment variable from Vite `import.meta.env` first,
 * then falls back to `process.env` (SSR / Node).
 */
function readSingleEnv(key: string): string | undefined {
  const viteEnv =
    typeof import.meta !== 'undefined' ? import.meta.env : undefined;
  if (viteEnv) {
    const fromVite = viteEnv[key as keyof ImportMetaEnv];
    if (typeof fromVite === 'string' && fromVite !== '') {
      return fromVite;
    }
  }
  return typeof process !== 'undefined' ? process.env[key] : undefined;
}

/**
 * Reads the first defined environment variable from the given keys.
 * Useful when the same value may be published under alternate prefixes
 * (e.g. `NEXT_PUBLIC_*` vs `VITE_*`).
 */
export function readEnv(...keys: string[]): string | undefined {
  for (const key of keys) {
    const value = readSingleEnv(key);
    if (value !== undefined) {
      return value;
    }
  }
  return undefined;
}

/** True when the first matching env value is the string `"true"`. */
export function readEnvFlag(...keys: string[]): boolean {
  return readEnv(...keys) === 'true';
}
